document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.jn-burger');
  var nav = document.querySelector('.jn-nav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var inputs = document.querySelectorAll('[data-cart-qty]');
  Array.prototype.forEach.call(inputs, function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
      input.disabled = false;
      form.submit();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.jn-subtoggle');
  Array.prototype.forEach.call(toggles, function (toggle) {
    toggle.addEventListener('click', function () {
      var sub = toggle.parentNode.querySelector('.jn-sub');
      if (!sub) return;
      var open = sub.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
});
